import { render, staticRenderFns } from "./type-verification.vue?vue&type=template&id=96e8d19e&"
import script from "./type-verification.vue?vue&type=script&lang=js&"
export * from "./type-verification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports